import React from 'react';
import { Link } from 'react-router-dom';
import PrimaryButton from './PrimaryButton';

const PageNotFound = () => {
  return (
    <main className='not-found-page container-large'>
      <section className='not-found-panel'>
        <div className='not-found-panel__header'>
          <p className='not-found-panel__eyebrow'>Lost page</p>
          <h1>404</h1>
          <h2>Page not found</h2>
          <p className='not-found-panel__intro'>
            The page you were trying to reach does not exist, or the link has
            changed. Use one of the routes below to get back into the site.
          </p>
        </div>
        <div className='not-found-panel__actions'>
          <PrimaryButton as={Link} to='/' label='Back Home' />
          <PrimaryButton
            as={Link}
            to='/writing'
            label='Explore Writing'
            tone='light'
          />
        </div>
      </section>
    </main>
  );
};

export default PageNotFound;
